import { useEffect } from 'react';
import { dispatcher } from 'dispatcher';
import { useDispatch } from 'react-redux';
import { prop } from 'ramda';

import { useUserSelector } from 'js/store/hooks';
import { useDynamicTags } from 'js/app/hooks/useDynamicTags';
import { DYNAMIC_TAG_NAMES } from '@interlayer/js/app/utils/constants';
import { getEyeconJackpots, getGamesGlobalJackpots } from 'js/components/common/Jackpot/buzz/server';
import { GLOBAL_GAMES_JACKPOT_DEFAULT_PREFIX } from '@interlayer/js/app/components/common/Jackpot/constants';
import { useFetchJackpots as useCoreFetchJackpots } from 'js/components/common/Jackpot/hooks/useFetchJackpots';

import * as actions from '../store/actions.buzz';

export const useFetchJackpots = () => {
    const dispatch = useDispatch();
    const currencyCode = useUserSelector(prop('currencyCode'));
    const [
        dTagUseServicesEyeconJackpots,
        dTagEyeconJackpotUrl,
        dTagGamesGlobalJackpotUrl,
        dTagGamesGlobalJackpotPrefix = GLOBAL_GAMES_JACKPOT_DEFAULT_PREFIX
    ] = useDynamicTags([
        DYNAMIC_TAG_NAMES.useServicesEyeconJackpots,
        DYNAMIC_TAG_NAMES.eyeconJackpotUrl,
        DYNAMIC_TAG_NAMES.gamesGlobalJackpotUrl,
        DYNAMIC_TAG_NAMES.gamesGlobalJackpotPrefix
    ]);

    useEffect(() => {
        if (dTagUseServicesEyeconJackpots && dTagEyeconJackpotUrl && currencyCode) {
            getEyeconJackpots({ dTagEyeconJackpotUrl, currencyCode })
                .then((response) => {
                    dispatch(actions.fetchEyeconJackpot(response));

                    dispatcher.dispatch('jackpots:eyecon', response);
                });
        }
    }, [currencyCode, dTagEyeconJackpotUrl, dTagUseServicesEyeconJackpots, dispatch]);

    useEffect(() => {
        if (dTagGamesGlobalJackpotUrl && currencyCode) {
            getGamesGlobalJackpots({ dTagGamesGlobalJackpotUrl, currencyCode })
                .then((jackpots) => {
                    dispatch(actions.fetchGamesGlobalJackpot({ jackpots, prefix: dTagGamesGlobalJackpotPrefix }));

                    dispatcher.dispatch('jackpots:gamesGlobal', jackpots);
                });
        }
    }, [currencyCode, dTagGamesGlobalJackpotPrefix, dTagGamesGlobalJackpotUrl, dispatch]);

    return useCoreFetchJackpots();
};
